// extracted by mini-css-extract-plugin
export default {"voteCard":"VoteCard_voteCard__WHGvl","frontCard":"VoteCard_frontCard__phEAf","selected":"VoteCard_selected__bl+ZY","shadow":"VoteCard_shadow__bTtAb"};